module.exports = __webpack_public_path__ + "img/Steor-Icons-03.5b1b6c10.svg";